import React, { useEffect, useState } from 'react';
import '../../styles/clientFilters.css';

const PREFERENCE_KEY = 'client-filters-expanded';
const PREFERENCE_EVENT = 'client-filters-preference-change';
const readExpanded = () => {
  try { return localStorage.getItem(PREFERENCE_KEY) !== 'false'; }
  catch { return true; }
};

export default function ClientFilters({ title, count, summary = [], primary, children }) {
  const [expanded, setExpanded] = useState(readExpanded);
  useEffect(() => {
    const sync = event => {
      if (event.type === PREFERENCE_EVENT) setExpanded(event.detail);
      else if (event.key === PREFERENCE_KEY || event.key === null) setExpanded(readExpanded());
    };
    window.addEventListener(PREFERENCE_EVENT, sync);
    window.addEventListener('storage', sync);
    return () => {
      window.removeEventListener(PREFERENCE_EVENT, sync);
      window.removeEventListener('storage', sync);
    };
  }, []);
  const toggleExpanded = () => {
    const next = !expanded;
    setExpanded(next);
    try { localStorage.setItem(PREFERENCE_KEY, String(next)); } catch { /* Storage may be unavailable. */ }
    window.dispatchEvent(new CustomEvent(PREFERENCE_EVENT, { detail: next }));
  };
  const description = summary.filter(Boolean).join(' · ') || 'Tous les résultats';
  return <section className={`client-filter-toolbar ${primary ? 'client-filter-toolbar--primary' : ''}`} aria-label={`En-tête ${title}`}>
    <div className="client-filter-toolbar__heading">
      <div className="client-filter-toolbar__primary">{primary || <><strong>{title}</strong><span className="client-filter-toolbar__count">{count}</span>
        <p>{description}</p></>}</div>
      {children && <button type="button" aria-expanded={expanded} onClick={toggleExpanded}>
        {primary ? (expanded ? 'Moins de filtres' : 'Filtres avancés') : (expanded ? 'Replier les filtres' : 'Déplier les filtres')} <span aria-hidden="true">{expanded ? '⌃' : '⌄'}</span>
      </button>}
    </div>
    {primary && !expanded && summary.some(Boolean) && <p className="client-filter-toolbar__summary">{description}</p>}
    {children && <div
      aria-hidden={!expanded}
      inert={expanded ? undefined : ''}
      className={`client-filter-toolbar__fields${expanded ? ' is-expanded' : ' is-collapsed'}`}
    ><div className="client-filter-toolbar__fields-inner">{children}</div></div>}
  </section>;
}
